import React from 'react';

export function Badge({ children, tone = 'blue', soft = true, dot = false, style = {}, ...rest }) {
  const tones = {
    blue:    { solid: { bg: 'var(--accent)',       fg: '#fff' },              soft: { bg: 'var(--accent-soft)',  fg: 'var(--accent)' } },
    green:   { solid: { bg: 'var(--energy)',       fg: 'var(--energy-contrast)' }, soft: { bg: 'var(--energy-soft)', fg: 'var(--success)' } },
    neutral: { solid: { bg: 'var(--neutral-700)',  fg: '#fff' },              soft: { bg: 'var(--neutral-100)', fg: 'var(--neutral-600)' } },
    warning: { solid: { bg: 'var(--warning)',      fg: '#fff' },              soft: { bg: '#fff2e2',            fg: 'var(--warning)' } },
    danger:  { solid: { bg: 'var(--danger)',       fg: '#fff' },              soft: { bg: '#fde8e8',            fg: 'var(--danger)' } },
  };
  const c = soft ? tones[tone].soft : tones[tone].solid;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: '0.45em',
      padding: '0.32em 0.8em', background: c.bg, color: c.fg,
      fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-xs)', fontWeight: 'var(--fw-bold)',
      letterSpacing: '0.02em', lineHeight: 1.4,
      borderRadius: 'var(--radius-pill)', whiteSpace: 'nowrap', ...style,
    }} {...rest}>
      {dot && <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'currentColor' }} />}
      {children}
    </span>
  );
}
